import React, { createContext } from 'react';

export const OrdersSadanContext = createContext();